<template>
  <article class="article-landing">
    <section id="landing-intro">
      <header class="intro-header">
        <img :src="`${publicPath}/plan/finnomena-port.png`" alt="ชอบแผนการลงทุนนี้" />
        <h1>ชอบแผนการลงทุนนี้?</h1>
        <p>
          เปิดบัญชีลงทุนกองทุนรวมกับเรา
          <span class="yellow">ฟรี! ไม่มีค่าใช้จ่าย</span>
        </p>
      </header>
      <div v-if="displayPromotion" id="promotion-desc">
        <h2>โปรโมชั่นพิเศษในเดือนนี้</h2>
        <p class="capsule">*สำหรับผู้ใช้ที่ไม่เคยลงทุนกับฟินโนมีนาเท่านั้น!</p>
        <div id="promotion-detail">
          <div class="row">
            <img :src="`${publicPath}/promotion/step-1@3x.png`" alt="step 1" />
            <div class="right">
              <div>
                <h3>สร้างแผนการลงทุนแรก</h3>
                <p>เริ่มต้นสร้างแผนลงทุนตามเป้าหมายที่คุณต้องการ ยกเว้นแผนการลงทุน DIY</p>
              </div>
            </div>
          </div>

          <div class="row">
            <img :src="`${publicPath}/promotion/step-2@3x.png`" alt="step 2" />
            <div class="right">
              <div>
                <h3>เปิดบัญชีลงทุนในแผนที่สร้างไว้</h3>
                <p>
                  <span class="orange">ใส่รหัส #FUND200</span> ในช่อง Referral Code จากนั้นทำรายการตัดบัญชีธนาคารอัตโนมัติ
                </p>
                <p
                  class="sub-paragraph"
                >(ถ้ามีผู้แนะนำการลงทุนดูแลอยู่ ใส่รหัสผู้ดูแล ตามด้วย #FUND200 ไม่ต้องเว้นวรรค)</p>
              </div>
            </div>
          </div>
          <div class="row">
            <img :src="`${publicPath}/promotion/step-3@3x.png`" alt="step 3" />
            <div class="right">
              <div>
                <h3>สร้างแผนการลงทุน DIY</h3>
                <p>
                  สร้างแผนการลงทุน DIY เพิ่มเป็นแผนที่ 2
                  เพื่อรอรับรางวัล ก่อนวันที่ 25 ก.ย. 62
                </p>
              </div>
            </div>
          </div>

          <div class="row">
            <img :src="`${publicPath}/promotion/step-4@3x.png`" alt="step 3" />
            <div class="right">
              <div>
                <h3>รับรางวัลขวัญถุง</h3>
                <p>
                  รับของรางวัลขวัญถุง ตามเงื่อนไขที่กำหนด
                  (หน่วยลงทุน TMBUSB มูลค่า 200 บาท)
                </p>
              </div>
            </div>
          </div>

          <a id="show-modal" @click="showModal = true">
            ดูเงื่อนไขโปรโมชั่น
            <i class="fas fa-angle-right"></i>
          </a>

          <modal v-if="showModal" @close="showModal = false">
            <h3 slot="header">เงื่อนไขโปรโมชั่น</h3>
            <div slot="body" class="condition">
              <ul>
                <li>ผู้รับสิทธิ์จะต้องไม่เคยเปิดบัญชีซี้อขายหน่วยลงทุนกับทาง FINNOMENA มาก่อน</li>
                <li>ผู้รับสิทธิ์จะต้องสร้างแผนลงทุนที่ 1 และเปิดบัญชีซื้อขายหน่วยลงทุนพร้อมทำรายการตัดบัญชีธนาคารอัตโนมัติเสร็จสมบูรณ์ (จะต้องได้รับการยืนยันเลขผู้ถือหน่วยลงทุนจาก FINNOMENA และการอนุมัติตัดบัญชีธนาคารอัตโนมัติ ATS เรียบร้อย ก่อนวันที่ 25 ก.ย. 62)</li>
                <li>แผนการลงทุนที่ 1 ที่เข้าร่วมโปรโมชั่น ได้แก่ 1st Million, Goal, GAR, GIF , GCP, TOP5, Best-in-class, Immunity, Plus, GURUPORT</li>
                <li>ผู้รับสิทธิ์จะต้องใส่รหัส #FUND200 ในช่อง Referral Code ในขั้นตอนการเปิดบัญชีเพื่อให้ครบเงื่อนไขในการรับของรางวัลตามโปรโมชั่น (หากคุณมีผู้แนะนำการลงทุนดูแลอยู่ ใส่รหัสผู้ดูแล ตามด้วย #FUND200 ไม่ต้องเว้นวรรค)</li>
                <li>ผู้รับสิทธิ์จะต้องสร้างแผน DIY เพิ่มอีก 1 แผน (โดยต้องได้รับการยืนยันเลขผู้ถือหน่วยลงทุนจาก FINNOMENA เรียบร้อย ก่อนวันที่ 25 ก.ย. 62)</li>
                <li>FINNOMENA จะดำเนินการจัดสรรหน่วยลงทุน TMBUSB ให้ผู้รับสิทธิ์ตามโปรโมชั่น โดยจะทำการวางคำสั่งซื้อหน่วยลงทุน TMBUSB ในบัญชีแผน DIY ของผู้รับสิทธิ์ และทำการชำระราคาค่าซื้อให้ โดยเริ่มดำเนินการตั้งแต่วันที่ 30 ก.ย. – 11 ต.ค. 62 เรียงลำดับตามเวลาที่เปิดบัญชีสำเร็จของผู้รับสิทธิ์</li>
                <li>เมื่อสิ้นสุดระยะเวลาโปรโมชั่น FINNOMENA จะดำเนินการพิจารณาผู้รับสิทธิ์ที่ปฏิบัติตามเงื่อนไขครบถ้วนและประกาศรายชื่อผู้ได้รับสิทธิ์ผ่านทางอีเมลของคุณ ในวันที่ 27 กันยายน 2562</li>
                <li>จำกัดสิทธิ์การได้รับของรางวัลเฉพาะ 4,000 คนแรกเท่านั้น ที่ปฏิบัติตามเงื่อนไขครบถ้วน โดย FINNOMENA จะพิจารณาจากเวลาที่เปิดบัญชีสำเร็จ และมีการปฏิบัติตามเงื่อนไขของโปรโมชั่นครบถ้วนโดยสมบูรณ์แล้วเท่านั้น</li>
                <li>ของรางวัล ได้แก่ หน่วยลงทุน TMBUSB โดยการอ้างอิงมูลค่าทรัพย์สินสุทธิ (Net Asset Value : NAV) ณ วันที่ทำรายการชำระราคาค่าซื้อ เพื่อจัดสรรให้กับผู้รับสิทธิ์เพื่อเป็นของรางวัล</li>
                <li>ในการเข้าร่วมโปรโมชั่นนี้ ผู้รับสิทธิทราบว่าของรางวัลเป็นหน่วยลงทุน TMBUSB และผู้รับสิทธิได้ทำความเข้าใจลักษณะสินค้า เงื่อนไขผลตอบแทนและความเสี่ยงของการลงทุนตามข้อมูล Fund Fact Sheet ของหน่วยลงทุน TMBUSB</li>
                <li>ของรางวัลไม่สามารถเปลี่ยนแปลงเป็นเงินสดได้</li>
                <li>บริษัทขอสงวนสิทธิ์ในการเปลี่ยนแปลงหรือยกเลิกเงื่อนไขและข้อตกลงโดยไม่ต้องแจ้งให้ทราบล่วงหน้า</li>
                <li>ในกรณีใด ๆ การตัดสินใจหรือการดำเนินการของ FINNOMENA ถือเป็นที่สิ้นสุด</li>
              </ul>
            </div>
          </modal>
        </div>
      </div>
    </section>

    <section id="landing-why">
      <header>
        <h2>
          ทำไมใครๆ ก็อยากลงทุน
          กับ บลน.FINNOMENA
        </h2>
      </header>
      <div class="why-items" v-lazy-container="{ selector: 'img' }">
        <div class="why-item">
          <img
            :data-srcset="`${publicPath}/plan/why-finnomena-1.png`"
            alt="เปิดบัญชีผ่านแอปได้ทันที"
          />
          <h3>เปิดบัญชีผ่านแอปได้ทันที</h3>
          <p>ไม่ต้องส่งเอกสารเพิ่ม แค่กรอกข้อมูลเปิดบัญชีผ่านแอปคุณก็พร้อมลงทุนภายใน 3 วัน</p>
        </div>

        <div class="why-item">
          <img
            :data-srcset="`${publicPath}/plan/why-finnomena-2.png`"
            alt="ระบบซื้อขายกองทุนรวมความสามารถสูง"
          />
          <h3>ระบบซื้อขายกองทุนรวมความสามารถสูง</h3>
          <p>ลงทุนได้รวดเร็วและปลอดภัย ผ่านแอป อินเตอร์เน็ตหรือโทรศัพท์</p>
        </div>

        <div class="why-item">
          <img
            :data-srcset="`${publicPath}/plan/why-finnomena-3.png`"
            alt="ลงทุนตามแผน หรือตามสไตล์คุณ"
          />
          <h3>ลงทุนตามแผน หรือตามสไตล์คุณ</h3>
          <p>ลงทุนตามคำแนะนำของ FINNOMENA หรือเลือกลงทุนเองผ่านกองทุนรวมจาก 14 บลจ.ในประเทศไทย</p>
        </div>

        <div class="why-item">
          <img :data-srcset="`${publicPath}/plan/why-finnomena-4.png`" alt="ปรับพอร์ตเมื่อจำเป็น" />
          <h3>ปรับพอร์ตเมื่อจำเป็น</h3>
          <p>รับคำแนะนำในการปรับปรุงพอร์ตจากกูรู FINNOMENA ตามแผนการลงทุนของคุณ พร้อมรับการเปลี่ยนแปลงทุกสภาวะตลาด</p>
        </div>

        <div class="why-item">
          <img
            :data-srcset="`${publicPath}/plan/why-finnomena-5.png`"
            alt="สิทธิพิเศษสำหรับนักลงทุน"
          />
          <h3>สิทธิพิเศษสำหรับนักลงทุน</h3>
          <p>เข้าร่วมสัมมนาทั้งออนไลน์และออฟไลน์ รับข้อมูลวิเคราะห์เจาะลึกตลาด และสิทธิพิเศษอื่นๆสำหรับนักลงทุน FINNOMENA เท่านั้น</p>
        </div>
      </div>
    </section>

    <section id="cta-landing">
      <a
        v-on:click="openAccount"
        data-action="click_open_account"
        class="cta-btn"
        id="openport-btn"
      >เปิดบัญชีกับ FINNOMENA</a>
    </section>
  </article>
</template>
<script>
import { sendAnalytic } from "../../utils/analytic";
import Modal from "../commons/Modal.vue";

export default {
  props: { userID: String, env: Object, finnakies: String },
  components: {
    Modal
  },
  data() {
    return {
      displayPromotion: false,
      publicPath: process.env.VUE_APP_SCONTENT_URL + "/line-liff",
      objQuery: {},
      endpoint: "",
      baseUrl: "",
      showModal: false
    };
  },
  metaInfo: {
    title: "FINNOMENA PORT"
  },
  async created() {},
  async mounted() {
    sendAnalytic({
      luid: this.userID,
      de: "line",
      ac: "open",
      ec: "create_flow",
      un: this.finnakies,
      et: "on_load",
      cu: "port_landing"
    });

    this.baseUrl = window.location.hostname;
    this.objQuery = this.$route.query;
  },
  methods: {
    openAccount() {
      sendAnalytic({
        luid: this.userID,
        de: "line",
        ac: "click_open_account",
        ec: "create_flow",
        un: this.finnakies,
        et: "on_click",
        cu: "port_landing"
      });

      this.$router.push({
        name: "appintro",
        params: {
          userID: this.userID,
          finnakies: this.finnakies
        },
        query: this.objQuery
      });
    }
  },
  updated() {}
};
</script>

<style lang="scss" scoped>
.header-finno {
  display: none;
}
.footer {
  display: none;
}
.article-landing {
  padding: 0px;
  margin: 0 auto;

  #landing-intro {
    background-color: #212121;
    margin: 0px;
    color: $color-white;
    padding: 32px 0px;

    .intro-header {
      background-image: img {
        width: 200px;
      }

      img {
        width: 180px;
        margin-left: 24px;
      }

      p {
        font-size: 14px;
        margin: 0px 0 0 16px;
        span {
          color: #ffcd00;
          font-weight: bold;
        }
      }

      h1 {
        margin: 20px 0 0 16px;
        font-size: 24px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
      }
    }

    #promotion-desc {
      color: #444444;
      border-radius: 7px;
      margin: 32px 16px 0 16px;
      background-color: $color-white;
      text-align: center;
      padding-top: 25px;

      #show-modal {
        font-size: 14px;
        color: $color-orange;
      }

      p {
        font-size: 12px;
      }

      .sub-paragraph {
        font-size: 10px;
      }

      .orange {
        color: #f7a501;
      }

      h2 {
        font-size: 18px;
        font-weight: bold;
        margin: 0px 0px 0px 0px;
      }

      .capsule {
        font-size: 12px;
        font-weight: normal;
        color: #f7a501;
        padding: 0 4px;
        margin: 0 auto;
        width: 240px;

        border-radius: 7px;
        background-color: #f9f9f9;
      }

      #promotion-detail {
        padding: 32px 0px;

        .row {
          display: flex;
          margin-bottom: 24px;
          vertical-align: middle;
          justify-content: center;

          img {
            width: 72px;
            height: 76px;
            object-fit: contain;
          }

          .right {
            text-align: left;
            margin-left: 20px;
            width: 64%;

            div {
              h3 {
                font-size: 16px;
                margin: 0;
              }

              p {
                margin: 0;
                font-size: 14px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #999999;
              }
            }
          }
        }

        .row:last-child {
          margin-bottom: 0px;
        }
      }

      h3 {
        font-size: 18px;
        margin: 32px 0 0 0 auto;
      }

      .condition {
        font-weight: normal;
        text-align: left;
        color: $color-secondary-text;
        font-size: 14px;
        padding: 0;

        ul {
          padding-left: 16px;
          li {
            margin-bottom: 6px;
            a {
              color: $color-orange;
            }
          }
        }
      }
    }

    .intro-desc {
      font-size: 16px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $color-secondary;
    }
    .intro-list {
      list-style: none;
      padding: 0;
      li {
        padding-left: 25px;
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #444444;
        position: relative;
        &:before {
          font-family: "Font Awesome 5 Pro";
          content: "\f067";
          color: $color-primary-finno;
          padding-right: 10px;
          position: absolute;
          left: 0;
          top: 3px;
          font-size: 18px;
        }
      }
    }
  }
  #landing-why {
    text-align: center;
    padding-bottom: 50px;
    header {
      h2 {
        font-size: 18px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #4a4a4a;
        margin: 48px 0px auto;
      }
    }
    .why-items {
      display: block;
      .why-item {
        display: inline-block;
        margin: 24px auto;
        max-width: 90%;
        img {
          max-height: 100px;
        }
        h3 {
          font-size: 18px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #444444;
          margin-bottom: 0px;
        }
        p {
          font-size: 16px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          margin-top: 2px;
          color: $color-secondary;
        }
      }
    }
  }
  #cta-landing {
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    text-align: center;

    .cta-btn {
      text-decoration: none;
      @extend %btn-primary;
      font-style: normal;
      font-stretch: normal;
      padding: 12.5px 0;
      width: -webkit-fill-available;
    }

    .cta-btn {
      text-decoration: none;
      @extend %btn-primary;
      font-style: normal;
      font-stretch: normal;
      padding: 12.5px 0;
      width: -webkit-fill-available;
    }
  }
}
</style>
